import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { FullProductLineMap } from 'self-service-api/constants/ProductLineMap';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import WhyGoHubSpotSection from '../components/WhyGoHubSpotSection';
import BannerSection from '../components/banners/BannerSection';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import FailedLoadBanner from '../components/common/loading/FailedLoadBanner';
import Faq from '../components/faqs/Faq';
import FooterMicrocopy from '../components/faqs/FooterMicrocopy';
import Question from '../components/faqs/Question';
import MobileHighlightedFreeCard from '../components/mobile/MobileHighlightedFreeCard';
import MobileSuiteFeatureTable from '../components/mobile/MobileSuiteFeatureTable';
import MobileWrapper from '../components/mobile/containers/MobileWrapper';
import { FaqsConfig } from '../constants/faqs/FaqsConfig';
import { NavItemEnum } from '../constants/routing/NavItems';
import { SCREENS } from '../constants/tracking/Screens';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useAppSelector } from '../reducers';
import { hasPricingAndPurchasingFailedSelector } from '../selectors/LoadingStateSelectors';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MobileFreeToolsPage = () => {
  useDocumentTitle('crm');
  useEffect(() => {
    trackPageView({
      screen: SCREENS.FREE
    });
  }, []);
  const hasPricingAndPurchasingFailed = useAppSelector(hasPricingAndPurchasingFailedSelector);
  const marketingFreeProduct = FullProductLineMap[ProductLines.MARKETING].highlightedFreeProduct;
  const salesFreeProduct = FullProductLineMap[ProductLines.SALES].highlightedFreeProduct;
  const serviceFreeProduct = FullProductLineMap[ProductLines.SERVICE].highlightedFreeProduct;
  const operationsFreeProduct = FullProductLineMap[ProductLines.OPERATIONS].highlightedFreeProduct;
  const cmsFreeProduct = FullProductLineMap[ProductLines.CMS].highlightedFreeProduct;
  const productsByProductLine = {
    [ProductLines.MARKETING]: [marketingFreeProduct],
    [ProductLines.SALES]: [salesFreeProduct],
    [ProductLines.SERVICE]: [serviceFreeProduct],
    [ProductLines.OPERATIONS]: [operationsFreeProduct],
    [ProductLines.CMS]: [cmsFreeProduct]
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(MobileWrapper, {
      navItem: NavItemEnum.FREE,
      navMarkerName: "FREE_TOOLS_PAGE",
      children: [/*#__PURE__*/_jsx(BannerSection, {
        screen: SCREENS.FREE
      }), /*#__PURE__*/_jsx(FailedLoadBanner, {
        hasFailed: hasPricingAndPurchasingFailed
      }), /*#__PURE__*/_jsxs(PPUIPageHeader, {
        children: [/*#__PURE__*/_jsx(ProductPageTitle, {
          nonProductIdentifier: NavItemEnum.FREE
        }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
          nonProductIdentifier: NavItemEnum.FREE
        })]
      }), /*#__PURE__*/_jsxs(PageSection, {
        children: [/*#__PURE__*/_jsx(CardGrid, {
          columns: 1,
          rowGap: "0",
          children: /*#__PURE__*/_jsx(MobileHighlightedFreeCard, {
            productLine: "crm",
            gridItemProps: {
              gridColumnStart: 1,
              paddingInline: '700',
              showBorderLeft: true,
              showBorderRight: true
            }
          })
        }), /*#__PURE__*/_jsx(MobileSuiteFeatureTable, {
          productLevel: FREE,
          productsByProductLine: productsByProductLine,
          screen: SCREENS.FREE
        })]
      }), /*#__PURE__*/_jsx(WhyGoHubSpotSection, {
        selectedNavItem: NavItemEnum.FREE
      }), /*#__PURE__*/_jsxs(Faq, {
        children: [FaqsConfig[NavItemEnum.FREE].map(_ref => {
          let {
              questionKey
            } = _ref,
            passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
          return /*#__PURE__*/_jsx(Question, Object.assign({
            questionKey: questionKey
          }, passthroughOptions), questionKey);
        }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
      })]
    })
  });
};
export default MobileFreeToolsPage;